import { useEffect, useState } from 'react';
import { FOUNDER } from '../config/business';
import { fetchFounderProfile, type FounderProfile } from '../services/teamApi';
import { getExpertAvatarUrl } from '../utils/imageUtils';

/**
 * Photo du fondateur, partagée par le hero et « Qui suis-je » :
 * 1. fichier officiel (FOUNDER.photo), 2. photo de profil du compte (API), sinon null.
 * N'afficher l'image qu'une fois `loading` à false, pour que l'étape 2 soit connue.
 */
export const useFounderPhoto = () => {
  const [founder, setFounder] = useState<FounderProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [stage, setStage] = useState<0 | 1 | 2>(0);

  useEffect(() => {
    let cancelled = false;
    fetchFounderProfile()
      .then((profile) => {
        if (!cancelled) setFounder(profile);
      })
      .catch((err) => console.error('[useFounderPhoto] chargement du profil', err))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const apiAvatar = founder?.profileImage ? getExpertAvatarUrl(founder.profileImage) : null;
  const photoUrl = stage === 0 ? FOUNDER.photo : stage === 1 && apiAvatar ? apiAvatar : null;

  const handlePhotoError = () => {
    setStage((current) => (current === 0 && apiAvatar ? 1 : 2));
  };

  return { founder, loading, photoUrl, handlePhotoError };
};
